class emergencyContact {
    constructor() {
        this.name = '',
		this.relationship = '',
		this.phone = '',
		this.phone_type = '',
		this.alt_phone = '',
		this.alt_phone_type = ''
    }
}

export default emergencyContact